import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import EDSFooter from '../components/EDSFooter';
import EDSHeader from '../components/EDSHeader';
import ApiService from '../services/ApiService';
import NotificationService from '../services/NotificationService';
import { setChName } from '../reducers/reposReducers';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../components/Elements/header/header';
import CustomInput from '../components/Elements/input/customInput';
import CustomButtons from '../components/Elements/Buttons/customButton';
import "./main.css"
const Rejestracja_haslo = () => {
    const [msg, setMsg] = useState("")
    const history = useHistory();
    const courseHeadingNameDispatch = useDispatch();
    var token = document.location.href.split('token=').splice(1).join('').split('&')[0];
    let arr = document.location.href.split('currentPurchaseKey=');
    var currentPurchaseKey = decodeURI(arr[1]);

    const apiService = new ApiService();
    const notificationService = NotificationService.getInstance();

    const [formData, setFormData] = useState({
        password: '',
        repeatedPassword: '',
    });
    const [header, setHeader] = useState('/  AKTYWACJA KONTA');
    const [loading, setLoading] = useState(false);
    const [tokenCorrect, setTokenCorrect] = useState(false);
    const [userLogin, setUserLogin] = useState('');
    const [isHiden, setIsHiden] = useState("password")
    const [isHiden2, setIsHiden2] = useState("password")
    const [isCorrectValue, setIsCorrectValue] = useState('')
    var currentLocation = window.location;
    let keyLink;
    
    if (
        currentLocation.href.split('/')[3] != undefined &&
        currentLocation.href.split('/')[3].split('currentPurchaseKey=')[1] != undefined
    ) {
        keyLink = currentLocation.href.split('/')[3].split('currentPurchaseKey=')[1];
        
    }
    function containsUppercase(str) {
        let lengthPassword =  str.length > 7;
        let unValidString = '';
        let bigLetter =  /[A-Z]/.test(str);
        let smallLetter =  /[a-z]/.test(str);
        let number =  /[0-9]/.test(str);
        let specialCharakter = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str);
            console.log(lengthPassword, str.length)
        if(bigLetter&&smallLetter&&number&&specialCharakter&&lengthPassword){
         
            setIsCorrectValue('')
            return true
        }else{
            
            if(!lengthPassword){
       
                unValidString += 'length|'
                setIsCorrectValue(unValidString)
            }
            else{
            if(!bigLetter){
                unValidString += 'big|'
            }
            if(!smallLetter){
                unValidString += 'small|'
            }
            if(!number){
                unValidString += 'number|'
            }
            if(!specialCharakter){
                unValidString += 'special|'
            }
            if(!bigLetter||!smallLetter||!number||!specialCharakter){
                setIsCorrectValue(unValidString)
            }}
            return false
        }

      }
    useEffect(() => {
        const checkTokenPayload = {
            resetToken: token,
            token,
        };

        const checkFailed = () => {
            history.push('/error_token_wygasl');
        };

        setLoading(true);
        apiService.apiPost(
            'CheckPasswordTokenStatus',
            checkTokenPayload,
            (response) => {
                setLoading(false);
                if (response.success) {
                    localStorage.setItem('response', JSON.stringify(response));
                    if (typeof response.data.registrationStatus === 'number') {
                        if (response.data.registrationStatus == 1) {
                            setTokenCorrect(true);
                            setUserLogin(response.data.userLogin);
                        } else {
                            checkFailed();
                        }
                    } else {
                        checkFailed();
                    }
                } else {
                    checkFailed();
                }
            },
            false
        );
    }, []);

    const save = (e) => {
        e.preventDefault();
        const proceed = () => {
            const payload = { passResetToken: token, password: formData.password };
            apiService.apiPostChange('UpdateUserFromPassResetToken', payload, (response) => {
                if (response.success) {
                    courseHeadingNameDispatch(setChName(currentPurchaseKey));
                    localStorage.setItem('keyURL', JSON.stringify(currentPurchaseKey));

                    if (response.data.message == 'strPassReset') {
                        if (keyLink != undefined) {
                            history.push('/login_haslo_zmienione/key=' + keyLink);
                        } else {
                            history.push('/login_haslo_zmienione');
                        }
                    } else if (response.data.message == 'strTokenExpired') {
                        history.push('/error_token_wygasl');
                    } else {
                        notificationService.showError();
                    }
                } else {
                    notificationService.showError();
                }
            });
        };
        if (typeof formData.password === 'string' && formData.password.length > 0) {
            if (
                typeof formData.repeatedPassword === 'string' &&
                formData.repeatedPassword.length > 0
            ) {
                if (formData.password === formData.repeatedPassword) {
                    proceed();
                } else {
                    setMsg('Wpisane hasła nie pasują do siebie');
                }
            } else {
                setMsg('Nie wpisano powtórzonego hasła');
            }
        } else {
            setMsg('Nie wpisano hasła');
        }
    };

    function render() {
        return (
            <>
                <Header>{header}</Header>

                <div className="content">{loading ? <></> : renderContent()}</div>

                <EDSFooter></EDSFooter>
            </>
        );
    }

    function changeViewCharacter (){
        if(isHiden == "password"){
        setIsHiden("")}else{
            setIsHiden("password") 
        }
    }
    function changeViewCharacter2 (){
        if(isHiden2 == "password"){
        setIsHiden2("")}else{
            setIsHiden2("password") 
        }
    }

    function renderContent() {
        if (tokenCorrect) {
            return (
                <div className="half-half">
                    <main className="margin-top-64">
                        <div className="loginChangePassword">
                            <h3 className="text-large">Login:</h3>
                            <div className="registration-email-box">
                                <span id="registration-user-email">{`${userLogin}`}</span>
                            </div>
                        </div>
                        <div className="loginChangePassword">
                            <h3 className="text-large">Ustal hasło</h3>
                            {/* <p className="margin-top-16">Hasło powinno składać się z...</p> */}
                            <form
                                id="set-password"
                                className="set-password"
                                method="post"
                                action=""
                                onSubmit={(e) => save(e)}
                            >
                                <div className="form__row margin-top-32">
                                    <CustomInput
                                        type={isHiden}
                                        isRequied={true}
                                        title="Hasło"
                                        showCalendary={(e) =>
                                            setFormData({
                                                ...formData,
                                                ...{ password: e },
                                            })
                                        }
                                        onChangeInput={(e) =>{
                                            if(containsUppercase(e)){
                                            setFormData({
                                                ...formData,
                                                ...{ password: e },
                                            })}else{
                                                console.log('duża litera')
                                            }}
                                        }
                                        icon={isHiden == "password"?<svg onClick={changeViewCharacter} width="22" height="22" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>:
                                        <svg onClick={changeViewCharacter} width="22" height="22" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>}
                                    />
                                </div>
                                {msg =='Nie wpisano hasła'&&isCorrectValue.includes('length')?<p className="msgInvalid">*Hasło musi składać się przynajmniej z 8 znaków</p>:""}

                                {msg =='Nie wpisano hasła'&&isCorrectValue.includes('big')?<p className="msgInvalid">*Hasło musi zawierać przynajmniej jedną wielką litere</p>:""}
                                {msg =='Nie wpisano hasła'&&isCorrectValue.includes('small')?<p className="msgInvalid">*Hasło musi zawierać przynajmniej jedną małą litere</p>:""}
                                {msg =='Nie wpisano hasła'&&isCorrectValue.includes('number')?<p className="msgInvalid">*Hasło musi zawierać przynajmniej jedną liczbe</p>:""}
                                {msg =='Nie wpisano hasła'&&isCorrectValue.includes('special')?<p className="msgInvalid">*Hasło musi zawierać przynajmniej jeden znak specjalny</p>:""}
                                <div className="form__row margin-top-32">
                                    <CustomInput
                                        type={isHiden}
                                        isRequied={true}
                                        title="Powtórz hasło"
                                        onChangeInput={(e) =>{
                                            
                                               setFormData({
                                                ...formData,
                                                ...{ repeatedPassword: e },
                                            })}
                                          
                                        }
                                   />
                                </div>
                                        {msg =='Nie wpisano powtórzonego hasła'?<p className="msgInvalid">*{msg}</p>:""}  
                                        {msg =='Wpisane hasła nie pasują do siebie'?<p className="msgInvalid">*{msg}</p>:""}
                                <CustomButtons
                                    clickFunction={(e) => {
                                   
                                         save(e);
                                    }}
                                    classButton="solid"
                                    size="big"
                                >
                                    ZATWIERDŹ
                                </CustomButtons>
                            </form>
                            </div>
                    </main>
                   
                </div>
            );
        } else {
            return <></>;
        }
    }

    return render();
};
export default Rejestracja_haslo;
